// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner-animation {
  animation: spinner 1.6s linear infinite;
  animation-delay: -1.6s;
}

.spinner-animation-secondary {
  animation-delay: -1s;
}

@keyframes spinner {
  12.5% {
    x: 13px;
    y: 1px;
  }
  25% {
    x: 13px;
    y: 1px;
  }
  37.5% {
    x: 13px;
    y: 13px;
  }
  50% {
    x: 13px;
    y: 13px;
  }
  62.5% {
    x: 1px;
    y: 13px;
  }
  75% {
    x: 1px;
    y: 13px;
  }
  87.5% {
    x: 1px;
    y: 1px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Reusable/RichTextEditor/src/styles/partials/animations.css"],"names":[],"mappings":"AAAA;EACE,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,OAAO;IACP,MAAM;EACR;EACA;IACE,OAAO;IACP,MAAM;EACR;EACA;IACE,OAAO;IACP,OAAO;EACT;EACA;IACE,OAAO;IACP,OAAO;EACT;EACA;IACE,MAAM;IACN,OAAO;EACT;EACA;IACE,MAAM;IACN,OAAO;EACT;EACA;IACE,MAAM;IACN,MAAM;EACR;AACF","sourcesContent":[".spinner-animation {\n  animation: spinner 1.6s linear infinite;\n  animation-delay: -1.6s;\n}\n\n.spinner-animation-secondary {\n  animation-delay: -1s;\n}\n\n@keyframes spinner {\n  12.5% {\n    x: 13px;\n    y: 1px;\n  }\n  25% {\n    x: 13px;\n    y: 1px;\n  }\n  37.5% {\n    x: 13px;\n    y: 13px;\n  }\n  50% {\n    x: 13px;\n    y: 13px;\n  }\n  62.5% {\n    x: 1px;\n    y: 13px;\n  }\n  75% {\n    x: 1px;\n    y: 13px;\n  }\n  87.5% {\n    x: 1px;\n    y: 1px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
